export default __webpack_public_path__ + "static/media/partner-skylab.af57afae.webp";